function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9239 -8250)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  transform: "translate(-9239 8250)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.304 23.567)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5672.85,1691.512a3.21,3.21,0,1,1,3.253-3.078A3.118,3.118,0,0,1,5672.85,1691.512Z",
  transform: "translate(-14950.666 6555.81)",
  fill: "#71aff8",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5546.888,1691.456a3.212,3.212,0,1,1,3.229-3.187A3.148,3.148,0,0,1,5546.888,1691.456Z",
  transform: "translate(-14833.738 6555.866)",
  fill: "#71aff8",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
  transform: "translate(-11955.898 7493.97)",
  fill: "#707070",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
  transform: "translate(-11947.516 7493.97)",
  fill: "#707070",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
  transform: "translate(-11939.133 7493.97)",
  fill: "#707070",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2668.477,757.555a3.249,3.249,0,0,1-3.264,3.27,3.264,3.264,0,0,1-.011-6.529A3.25,3.25,0,0,1,2668.477,757.555Zm-3.279,1.661a1.656,1.656,0,1,0-1.657-1.654A1.613,1.613,0,0,0,2665.2,759.216Z",
  transform: "translate(-11947.516 7479.775)",
  fill: "#707070",
  fillRule: "evenodd"
})));

function SvgIconNgc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNgc);
export default __webpack_public_path__ + "static/media/icon-ngc.3eb0d59b.svg";
export { ForwardRef as ReactComponent };